package it.neckar.lizergy.model.configuration.quote.builder

import it.neckar.lizergy.lifeCycle.LizergyHasLifeCycle
import it.neckar.lizergy.lifeCycle.LizergyLifeCycleState
import it.neckar.uuid.HasValueClassUuid
import it.neckar.uuid.NativeUuid
import it.neckar.uuid.ValueClassUuid
import it.neckar.uuid.randomForEnvironment
import kotlinx.serialization.Serializable
import kotlin.uuid.Uuid

@Serializable
data class Manufacturer(
  override val id: ManufacturerId,
  val name: String,
  override val lifeCycleState: LizergyLifeCycleState = LizergyLifeCycleState.Active,
) : HasValueClassUuid, LizergyHasLifeCycle {

  @Serializable
  data class ManufacturerId(override val uuid: NativeUuid) : ValueClassUuid {

    override fun toString(): String {
      return uuid.toString()
    }

    fun format(): String {
      return uuid.toString()
    }

    companion object {
      fun random(): ManufacturerId {
        return ManufacturerId(Uuid.randomForEnvironment())
      }
    }
  }


  companion object {
    val SMA: Manufacturer = Manufacturer(ManufacturerId(Uuid.parse("5c8d7151-8b70-4fa6-b809-94532619567f")), "SMA")
    val IBC: Manufacturer = Manufacturer(ManufacturerId(Uuid.parse("f0ec3b1d-6c05-48f1-b816-603402ac3020")), "IBC")
    val KEBA: Manufacturer = Manufacturer(ManufacturerId(Uuid.parse("52d6b32b-a177-45f0-b5f3-8f45f8132f54")), "KEBA")
  }
}
